import { useCallback, useEffect } from "react"
import { throttle } from "radash"
import { useInView } from "react-intersection-observer"

const useInfiniteLoading = ({ onIntersect }: any) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const throttledCb = useCallback(throttle({ interval: 400 }, onIntersect), [])

  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
  })

  useEffect(() => {
    if (inView) {
      throttledCb()
    }
  }, [inView, throttledCb])

  return { ref } as const
}

export { useInfiniteLoading }
